import { createAction, props } from '@ngrx/store';

export const saveBraches = createAction(
    '[AUTH] save branches',
    props<{ value: any }>(),
);
